import {Component,Inject, Input, Output} from 'ng-metadata/core';
import {Upload} from 'ng-file-upload';
import { UploadFileService } from './uploadFile.service';

//your imports go here

@Component({
    "selector": 'prm-upload-file',
    templateUrl: 'components/infra/deposit/uploadFile/upload-file.html',
})

export class PrmUploadFile{
	@Input() public amazoninfo: Object;
	@Input() public depositfiles: Object[]=[];
	@Input() public depositprofile: Object;
	private _mode:string = 'normal';
	private _filesFormat:string = "*";
	private _filename: string;
	private allowSelect:string = 'hover';
	private amazonFileKey:string;

    constructor(@Inject('accountIcons') public accountIcons,
                @Inject('Upload') public Upload,
                private uploadFileService : UploadFileService) {
    }

	get mode(){
		return this._mode;
	}

	set mode(mode){
		this._mode = mode;
	}

	get filesFormat(){
		return this._filesFormat;
	}

	set filesFormat(filesFormat){
		this._filesFormat = filesFormat;
	}

	get files(){
		return this.uploadFileService.files;
	}
	set files(files){
		this.uploadFileService.files = files;
	}

	get filename(){
		return this._filename;
	}

	set filename(filename){
		this._filename = filename;
	}

	get fileFailed(){
		return this.uploadFileService.fileFailed;
	}

	public upload(){

		this.uploadFileService.depositProfile=this.depositprofile;
		this.uploadFileService.amazonInfo=this.amazoninfo;
		this.uploadFileService.uploadFiles(this.depositfiles);
	}
 }


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/deposit/uploadFile/uploadFile.directive.ts